import React from "react";
import { LogIn, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Card from "../components/ui/Card";
import PrimaryButton from "../components/ui/PrimaryButton";
import { useAuth } from "../context/AuthContext";
import "./ProfilePage.css";

const ProfilePage: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const displayName = user?.name?.trim() ? user.name : "EarlySpot member";
  const avatarInitial = user
    ? (displayName.charAt(0) || "E").toUpperCase()
    : "G";

  return (
    <div className="profile">
      <Card padding="lg" className="profile__card" elevated>
        <div className="profile__header">
          <div className="profile__avatar">{avatarInitial}</div>
          <div>
            <h2>{user ? displayName : "Guest session"}</h2>
            <p>
              {user
                ? "Your history is saved to your account."
                : "Log in to sync scans across devices."}
            </p>
          </div>
        </div>
        {user ? (
          <div className="profile__badges">
            <div className="profile__badge">Account mode</div>
            <div className="profile__badge">Care plan: Preventative</div>
          </div>
        ) : null}
        {user ? (
          <PrimaryButton
            icon={<LogOut size={18} strokeWidth={2.2} />}
            style={{ alignSelf: "flex-start" }}
            onClick={logout}
          >
            Logout
          </PrimaryButton>
        ) : (
          <PrimaryButton
            icon={<LogIn size={18} strokeWidth={2.2} />}
            style={{ alignSelf: "flex-start" }}
            onClick={() => navigate("/login")}
          >
            Login to save history
          </PrimaryButton>
        )}
      </Card>

      <Card padding="md" className="profile__support">
        <h3>Need help?</h3>
        <p>Contact us if you have issues.</p>
        <div className="profile__links">
          <a
            href="https://www.cancer.org.au/cancer-information/types-of-cancer/melanoma"
            target="_blank"
            rel="noreferrer"
          >
            Learn about skin cancer
          </a>
          <a href="mailto:krusgangurde@gmail.com">Contact support</a>
        </div>
      </Card>
    </div>
  );
};

export default ProfilePage;
